import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "button", "content", "icon"]

  toggle(event) {
    const button = event.currentTarget
    const item = button.closest("[data-accordion-target='item']")
    const content = item.querySelector("[data-accordion-target='content']")
    const icon = item.querySelector("[data-accordion-target='icon']")

    if (content.classList.contains("hidden")) {
      // Open
      content.classList.remove("hidden")
      icon.classList.add("rotate-180")
    } else {
      // Close
      content.classList.add("hidden")
      icon.classList.remove("rotate-180")
    }
  }

  // Expand all items
  expandAll() {
    this.itemTargets.forEach(item => {
      const content = item.querySelector("[data-accordion-target='content']")
      const icon = item.querySelector("[data-accordion-target='icon']")
      content.classList.remove("hidden")
      icon.classList.add("rotate-180")
    })
  }

  // Collapse all items
  collapseAll() {
    this.itemTargets.forEach(item => {
      const content = item.querySelector("[data-accordion-target='content']")
      const icon = item.querySelector("[data-accordion-target='icon']")
      content.classList.add("hidden")
      icon.classList.remove("rotate-180")
    })
  }
}
